import * as ar from '../../../../../../config/locales/js/ar.json';
angular.module('cerego.translate').constant('translateAr', ar);
